import React, { useState, useEffect } from "react";
import ReactSelect from "react-select";
import CloudStorage from "../../CloudStorage/CloudStorage";
import { isDuplicateSkill } from "../../utils/skillUtils";
import { urtoast } from "../Layouts/CustomPopup/eventEmitter";

export default function CommonAddSkills({
  popularSkills = [],
  allSkills = [],
  parentselectedskills = [],
  formik,
}) {
  const [addmanual, setAddmanual] = useState(false);
  const [manualSkill, setManualSkill] = useState("");
  const selectedSkills = Array.isArray(parentselectedskills) ? parentselectedskills : [];

  // ✅ Dropdown skill selection
  const handleLanguageChange = (selectedOption) => {
    if (isDuplicateSkill(selectedOption.value, selectedSkills)) {
      urtoast("Duplicate Skill Not allowed.", 2);
      return;
    }
    const newSkill = { id: selectedOption.value, title: selectedOption.label };
    const updated = [...selectedSkills, newSkill];
    formik.setFieldValue("skills", updated);
  };

  // ✅ Add popular skill
  const handleAddPopularSkill = (skill) => {
    if (isDuplicateSkill(skill.id, selectedSkills)) {
      urtoast("Duplicate Skill Not allowed.", 2);
      return;
    }
    const updated = [...selectedSkills, skill];
    formik.setFieldValue("skills", updated);
  };

  // ✅ Delete skill
  const handleDeleteSkill = (id) => {
    const updated = selectedSkills.filter((s) => s.id !== id);
    formik.setFieldValue("skills", updated);
  };

  // ✅ Add manual skill
  const handleAddManualSkill = () => {
    const trimmed = manualSkill.trim();
    if (!trimmed) return;

    const duplicate =
      isDuplicateSkill(trimmed, selectedSkills) ||
      (Array.isArray(allSkills) &&
        allSkills.some(
          (skill) => skill.title.toLowerCase() === trimmed.toLowerCase()
        ));

    if (duplicate) {
      urtoast("Duplicate Skill Not allowed.", 2);
      return;
    }

    const newSkill = { id: trimmed, title: trimmed };
    const updated = [...selectedSkills, newSkill];
    formik.setFieldValue("skills", updated);
    setManualSkill("");
    setAddmanual(false);
  };



  return (
    <div className="form-group skill-sec">
      <label>Competencies</label>

      {/* React Select */}
      <div className="skill-img">
        <button className="btn skill-img-btn">
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/select-icon.svg`}
            alt=""
          />
        </button>

        <ReactSelect
          options={
            Array.isArray(allSkills)
              ? allSkills
                .filter((lang) => !isDuplicateSkill(lang.id, selectedSkills))
                .map((lang) => ({ value: lang.id, label: lang.title }))
              : []
          }
          placeholder="Select competencies"
          value={null}
          onChange={(option) => option && handleLanguageChange(option)}
        />
      </div>

      <p className="add-skill-p-sec">Add up to 5 competencies for best results</p>

      <button
        className="add-plus btn"
        type="button"
        onClick={() => setAddmanual(true)}
      >
        + Add competencies manually
      </button>

      {formik.submitCount > 0 && selectedSkills.length < 3 && (
        <p style={{ color: "red" }}>At least add 3 competencies</p>
      )}

      {/* Manual skill input */}
      {addmanual && (
        <div className="manualskill-input">
          <input
            type="text"
            value={manualSkill}
            onChange={(e) => setManualSkill(e.target.value)}
            placeholder="Type a competency"
            onKeyDown={(e) => {
              if (e.key == "Enter") {
                e.preventDefault();
                handleAddManualSkill();
              }
            }}
          />
          <button type="button" onClick={handleAddManualSkill}>
            Add
          </button>
          <button type="button" onClick={() => setAddmanual(false)}>
            Close
          </button>
        </div>
      )}

      <div className="add-skills">
        {Array.isArray(selectedSkills) &&
          selectedSkills.map((skill, i) => (
            <div key={i}>
              <p onClick={() => handleDeleteSkill(skill.id)}>
                {skill.title} <span>x</span>
              </p>
            </div>
          ))}
      </div>

      {Array.isArray(popularSkills) && popularSkills.length > 0 && (
        <div className="popular-skill">
          <h5>Popular competencies based on your designation</h5>
          <div className="add-skills">
            {popularSkills
              .filter((lang) => !isDuplicateSkill(lang.id, selectedSkills))
              .map((skill, i) => (
                <div key={i}>
                  <p
                    className="select-deactive-skill"
                    onClick={() => handleAddPopularSkill(skill)}
                  >
                    {skill.title} <span>+</span>
                  </p>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}
